class CAMCFundFilter {
    /**
     * @param {Set} fundData - The fund data set
     * @param {Element} containerElement - The container DOM element
     * @param {Function} onFilterChange - Callback function called when filter changes, receives (filteredData)
     */
    constructor(fundData, containerElement, onFilterChange) {
        // Core data - each instance has its own copy
        this.fundData = fundData;
        this.fundDataSize = this.fundData.size;

        // DOM references - scoped to this container only
        this.$container = $(containerElement);
        this.$rootEl = this.$container.find(".camc-fund-list-filter");
        this.$accordion = this.$rootEl.find(".camc-fund-list-filter__accordion");
        this.category = {
            $type: this.$rootEl.find(".filter-category.filter-category--type"),
            $risk: this.$rootEl.find(".filter-category.filter-category--risk"),
        };

        // Generate unique containerId for URL parameter keys
        const rawId = this.$container.attr("id") || `fl${Date.now()}`;
        this.containerId = rawId.replace(/[^0-9]/g, "") || rawId;
        this.storageKeyPrefix = `fl${this.containerId}`;

        // Instance-specific state
        this.apiFundtypes = new Set();
        this.apiRisktypes = new Set();
        this.selectedLabelSet = new Set();
        this.condition = { fundType: new Set(), riskRating: new Set() };

        // Callback to notify parent when filter changes
        this.onFilterChange = onFilterChange || (() => {});

        // Initialize
        this.setApiConditons();
        this.init();
        this.bindEvents();
    }

    bindEvents() {
        const _this = this;

        //bind mobile filter selections show and hide events
        this.$accordion.find(".accordion-title").click(function (e) {
            $(this).toggleClass("is-active");
            _this.$rootEl.find(".camc-fund-list-filter__group").toggleClass("hide-for-small-only");
        });

        //bind click filter events
        this.$rootEl.find(".fil-chip--multiselect[active!='false']").click(function (e) {
            e.preventDefault();
            var $el = $(this);
            if ($el.hasClass("panel-item")) {
                const name = $el.attr("name");
                $el.remove();
                $el = _this.$rootEl.find(`.fil-chip--multiselect[active!='false'][name=${name}]`);
                _this.filterButtonClick($el);
            } else {
                _this.filterButtonClick($el);
                const name = $(this).attr("name");
                const $item = _this.$accordion.find(`.panel-item[name=${name}]`);
                if ($item.length) {
                    $item.remove();
                } else {
                    $el.clone(true).addClass("panel-item").appendTo(_this.$accordion.find(".selected-items-panel"));
                }
            }
            // Find the checkbox within the same filter-category
            const type = $el.attr("type").split("fund-").pop();
            const $filterCategory = _this.$rootEl.find(`.filter-category--${type}`);
            const $checkbox = $filterCategory.find(".fil-checkbox input[type=checkbox]");

            if ($checkbox.prop("checked")) {
                $checkbox.prop("checked", false);
            }
            // Check if all items in this category are selected
            if (
                $filterCategory.find(`.fil-chip--multiselect:not(".fil-chip--disabled"):not(".fil-chip--selected")`)
                    .length === 0
            ) {
                $checkbox.prop("checked", true);
            }
        });

        //bind select all filters events
        this.$rootEl.find(".fil-checkbox input[type=checkbox]").on("change", function () {
            const $checkbox = $(this);
            const isChecked = $checkbox.prop("checked");
            const $filterCategory = $checkbox.closest(".filter-category");

            $filterCategory.find(".filter-list .fil-chip--multiselect[active!='false']").each(function () {
                const $el = $(this);
                if (isChecked) {
                    if (!$el.hasClass("fil-chip--selected")) {
                        $el.addClass("fil-chip--selected");
                        $el.find(".fil-chip__label").prepend(_this.checkboxIcon);
                        _this.selectedLabelSet.add($el.attr("name"));
                        $el.clone(true).addClass("panel-item").appendTo(_this.$accordion.find(".selected-items-panel"));
                    }
                } else {
                    $el.removeClass("fil-chip--selected");
                    $el.find(".fil-chip__label").find("fil-icon-custom-tick").remove();
                    _this.$accordion.find(`.panel-item[name="${$el.attr("name")}"]`).remove();
                    _this.selectedLabelSet.delete($el.attr("name"));
                }
            });
            _this.saveSelectedLabels();
            _this.handleFilterChange();
        });

        //bind clear filter events
        this.$rootEl.find(".fund-list-clear").click(function (e) {
            _this.$rootEl.find(".fil-chip--multiselect").each(function () {
                const $el = $(this);
                $el.removeClass("fil-chip--selected");
                $el.find("fil-icon-custom-tick").remove();
            });
            _this.$rootEl.find(".fil-checkbox input[type=checkbox]").prop("checked", false);
            _this.$accordion.find(".panel-item").each(function () {
                $(this).remove();
            });
            _this.$accordion.find(".accordion-title-filter").hide();
            _this.selectedLabelSet.clear();
            _this.saveSelectedLabels();
            _this.handleFilterChange();
        });

        _this.width = $(window).width();

        $(window).on("resize", () => {
            if ($(window).width() != _this.width) {
                _this.handleMobileFilterDislay();
            }
            _this.width = $(window).width();
        });
    }

    init() {
        this.checkboxIcon = `
        <fil-icon-custom-tick>
            <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Navigation/custom-tick" transform="translate(0.5833, 1.5833)" fill="#026FAD" fill-rule="nonzero">
                        <g id="Stroke">
                            <path d="M7.53432581,0.239043278 C7.81652108,-0.0641706778 8.29108903,-0.081209686 8.59430299,0.200985588 C8.89751694,0.483180861 8.91455595,0.957748808 8.63236068,1.26096276 L3.79902731,6.45429612 C3.52267281,6.75123427 3.06030939,6.77463524 2.7553868,6.50711648 L0.255386796,4.31378312 C-0.0559803578,4.04061034 -0.0869430108,3.56674709 0.186229775,3.25537994 C0.45940256,2.94401278 0.933265808,2.91305013 1.24463296,3.18622292 L3.19600988,4.89900302 L7.53432581,0.239043278 Z" id="Adjust-Stroke-Width"></path>
                        </g>
                    </g>
                </g>
            </svg>
        </fil-icon-custom-tick>`;

        const _this = this;

        // Restore filter state from URL
        const savedLabels = this.getStorageItem("sel");
        if (savedLabels) {
            const params = savedLabels.split(",");
            params.forEach((item) => {
                if ([...this.apiFundtypes].includes(item)) {
                    this.condition["fundType"].add(item);
                } else if ([...this.apiRisktypes].includes(item)) {
                    this.condition["riskRating"].add(item);
                }
            });
            this.selectedLabelSet = new Set(params);
        }

        // Restore UI state based on saved selections
        this.$rootEl.find(".fil-chip--multiselect").each(function () {
            if ([..._this.selectedLabelSet].includes($.trim($(this).attr("name")))) {
                $(this).addClass("fil-chip--selected");
                $(this).find(".fil-chip__label").prepend(_this.checkboxIcon);
                $(this).clone(true).addClass("panel-item").appendTo(_this.$accordion.find(".selected-items-panel"));
            }
        });

        // Check "select all" checkboxes if all items in category are selected
        if (
            _this.$rootEl.find(
                `.fil-chip--multiselect[type=fund-type]:not(".fil-chip--disabled"):not(".fil-chip--selected")`,
            ).length === 0
        ) {
            const $checkbox = _this.$rootEl.find(".filter-category--type .fil-checkbox input[type=checkbox]");
            $checkbox.prop("checked", true);
        }
        if (
            _this.$rootEl.find(
                `.fil-chip--multiselect[type=fund-risk]:not(".fil-chip--disabled"):not(".fil-chip--selected")`,
            ).length === 0
        ) {
            const $checkbox = _this.$rootEl.find(".filter-category--risk .fil-checkbox input[type=checkbox]");
            $checkbox.prop("checked", true);
        }

        this.handleMobileFilterDislay();

        // Notify parent with initial filtered data (based on restored filter state)
        this.updateConditions();
        this.onFilterChange(this.getFilteredData());

        // Setup MutationObserver for selected items panel
        const targetNode = _this.$accordion.find(".selected-items-panel")[0];
        if (targetNode) {
            const config = { attributes: true, childList: true, subtree: true };
            const callback = function (mutationsList, observer) {
                for (let mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        if (targetNode.children.length > 0) {
                            _this.$accordion.find(".accordion-title-filter").show();
                        } else {
                            _this.$accordion.find(".accordion-title-filter").hide();
                        }
                    }
                }
            };
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    }

    handleMobileFilterDislay() {
        const $panel = this.$accordion.find(".selected-items-panel");
        if ($panel.find(".panel-item").length != 0) {
            this.$accordion.find(".accordion-title").addClass("is-active");
            this.$accordion.find(".accordion-title-filter").show();
            this.$rootEl.find(".camc-fund-list-filter__group").removeClass("hide-for-small-only");
        } else {
            this.$accordion.find(".accordion-title").removeClass("is-active");
            this.$accordion.find(".accordion-title-filter").hide();
            this.$rootEl.find(".camc-fund-list-filter__group").addClass("hide-for-small-only");
        }
    }

    setApiConditons() {
        const _this = this;
        _this.fundData.forEach((fund) => {
            _this.apiFundtypes.add(fund.fundType);
            _this.apiRisktypes.add(fund.riskRating);
        });

        _this.$rootEl.find(".fil-chip--multiselect").each(function () {
            const $this = $(this);
            if (_this.apiFundtypes.has($this.attr("name")) || _this.apiRisktypes.has($this.attr("name"))) {
                $this.removeAttr("active");
                $this.removeClass("fil-chip--disabled");
            }
        });

        if (_this.apiFundtypes.size > 0) _this.category.$type.find(".fil-checkbox input").removeAttr("disabled");
        if (_this.apiRisktypes.size > 0) _this.category.$risk.find(".fil-checkbox input").removeAttr("disabled");
    }

    updateConditions() {
        const _this = this;
        _this.condition["fundType"].clear();
        _this.$rootEl.find(".filter-category.filter-category--type .filter-list .fil-chip--selected").each(function () {
            const label = $(this).attr("name");
            _this.condition["fundType"].add(label);
        });

        _this.condition["riskRating"].clear();
        _this.$rootEl.find(".filter-category.filter-category--risk .filter-list .fil-chip--selected").each(function () {
            const label = $(this).attr("name");
            _this.condition["riskRating"].add(label);
        });
    }

    // URL parameter helper methods for state persistence
    getUrlParam(key) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(`${this.storageKeyPrefix}_${key}`);
    }

    setUrlParam(key, value) {
        const url = new URL(window.location.href);
        const paramKey = `${this.storageKeyPrefix}_${key}`;

        if (value !== null && value !== undefined && value !== "") {
            url.searchParams.set(paramKey, value);
        } else {
            url.searchParams.delete(paramKey);
        }

        window.history.replaceState({}, "", url.toString());
    }

    // Alias methods for backward compatibility
    getStorageItem(key) {
        return this.getUrlParam(key);
    }

    setStorageItem(key, value) {
        this.setUrlParam(key, value);
    }

    saveSelectedLabels() {
        const labels = [...this.selectedLabelSet].join(",");
        this.setUrlParam("sel", labels);
    }

    filterButtonClick($el) {
        const labelName = $el.attr("name");
        $el.toggleClass("fil-chip--selected");
        if ($el.hasClass("fil-chip--selected")) {
            $el.find(".fil-chip__label").prepend(this.checkboxIcon);
            this.selectedLabelSet.add(labelName);
        } else {
            $el.find(".fil-chip__label").find("fil-icon-custom-tick").remove();
            this.selectedLabelSet.delete(labelName);
        }
        this.saveSelectedLabels();
        this.handleFilterChange();
    }

    handleFilterChange() {
        this.updateConditions();
        // Notify parent controller with filtered data
        this.onFilterChange(this.getFilteredData());
    }

    getFilteredData() {
        return new Set(
            [...this.fundData].filter((item) => {
                return Object.keys(this.condition).every((key) => {
                    if (this.condition[key].size == 0) {
                        return true;
                    }
                    return [...this.condition[key]].includes(item[key]);
                });
            }),
        );
    }
}

export default CAMCFundFilter;
